import PropTypes from 'prop-types';
import classNames from 'classnames';

function PasswordStrengthIndicator(props) {
  const strengthNumber = Number(props.level) || 0;
  let level;
  switch (Number(strengthNumber)) {
    case 1:
      level = 'Weak';
      break;
    case 2:
      level = 'Strong';
      break;
    case 3:
      level = 'Awesome';
      break;
    default:
      level = 'Very Weak';
  }
  return (
    <>
      <span
        className={classNames(
          'flex content-center text-sm font-bold border-b-3 h-100',
          strengthNumber < 2 ? 'text-error-900' : 'text-primary-500',
        )}
      >
        {level}
      </span>
    </>
  );
}

PasswordStrengthIndicator.propTypes = {
  level: PropTypes.number,
};

export default PasswordStrengthIndicator;
